<template>
  <div>
    <el-dialog
      class="process-mind-map-dialog process-mind-map-source-dialog incoming-stkin-list-dialog"
      v-dialogDrag
      :visible.sync="innerVisible"
      width="96vw"
      append-to-body
      top="4vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @open="loadData"
      @closed="resetData">
      <div slot="title" class="incoming-stkin-dialog__title">
        <span>{{ $LANG('', '质检入库单') }}</span>
      </div>
      <div class="incoming-stkin-dialog__body">
        <div class="incoming-stkin-dialog__filters">
          <el-input
            v-model="filters.materialCode"
            size="mini"
            clearable
            :placeholder="$LANG('', '物料编码')"
            :aria-label="$LANG('', '物料编码')">
          </el-input>
          <el-input
            v-model="filters.supplierName"
            size="mini"
            clearable
            :placeholder="$LANG('', '供应商名称')"
            :aria-label="$LANG('', '供应商名称')">
          </el-input>
          <el-button class="incoming-stkin-dialog__reset" size="mini" @click="resetFilters">{{ $LANG('', '重置') }}</el-button>
        </div>
        <el-table
          :data="filteredTableData"
          border
          size="small"
          ref="listTable"
          class="custom-table-border incoming-stkin-dialog__table"
          v-loading="loading"
          :element-loading-text="$LANG('1959', '加载中')"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 251, 255, 0.8)"
          :cell-style="{ padding: '2px' }"
          :header-cell-style="headStyle"
          cell-class-name="clearPadding2"
          height="calc(88vh - 97px)"
          highlight-current-row>
          <el-table-column :label="$LANG('0310', '序号')" type="index" width="60" fixed></el-table-column>
          <el-table-column
            v-for="item in visibleColumns"
            :key="item.key"
            :prop="item.key"
            :label="item.title"
            show-overflow-tooltip
            :align="item.align"
            :sortable="item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'"
            :min-width="item.width">
            <template slot-scope="scope">
              <el-checkbox
                v-if="item.edcss === 'checkbox'"
                disabled
                true-label="Y"
                false-label="N"
                v-model="scope.row[item.key]">
              </el-checkbox>
              <el-link v-else-if="item.key === 'IDNO'" :underline="false" @click="openDetail(scope.row, 'view')">
                <span class="incoming-stkin-dialog__idno">{{ displayText(scope.row[item.key]) }}</span>
              </el-link>
              <el-tag
                v-else-if="isYesNoField(item)"
                size="mini"
                :type="scope.row[item.key] === 'Y' ? 'success' : 'info'"
                effect="dark">
                {{ scope.row[item.key] === 'Y' ? $LANG('2047', '是') : $LANG('2044', '否') }}
              </el-tag>
              <span v-else v-text="displayText(scope.row[item.key])"></span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$LANG('0330', '操作')"
            align="center"
            width="132">
            <template slot-scope="scope">
              <div class="incoming-stkin-dialog__action-group">
                <el-tooltip :content="$LANG('0139', '查看')" placement="top" effect="light">
                    <el-button
                      class="incoming-stkin-dialog__action-button"
                      type="text"
                      size="mini"
                      icon="iconfont icon-chakan"
                      :aria-label="$LANG('0139', '查看')"
                      @click="openDetail(scope.row, 'view')">
                    </el-button>
                </el-tooltip>
                <template v-if="scope.row.STFG === 'N'">
                  <el-tooltip :content="$LANG('1639', '编辑')" placement="top" effect="light">
                      <el-button
                        class="incoming-stkin-dialog__action-button"
                        type="text"
                        size="mini"
                        icon="iconfont icon-bianji"
                        :disabled="editBool"
                        :aria-label="$LANG('1639', '编辑')"
                        @click="openDetail(scope.row, 'edit')">
                      </el-button>
                  </el-tooltip>
                  <el-tooltip :content="$LANG('0134', '审核')" placement="top" effect="light">
                      <el-button
                        class="incoming-stkin-dialog__action-button"
                        type="text"
                        size="mini"
                        icon="iconfont icon-shenhe"
                        :disabled="delBool"
                        :aria-label="$LANG('0134', '审核')"
                        @click="setStatus(scope.row, 'Y')">
                      </el-button>
                  </el-tooltip>
                </template>
                <template v-else-if="scope.row.STFG === 'Y'">
                  <el-tooltip :content="$LANG('0242', '下推')" placement="top" effect="light">
                      <el-button
                        class="incoming-stkin-dialog__action-button"
                        type="text"
                        size="mini"
                        icon="iconfont icon-xiashuangjiantou"
                        :disabled="editBool"
                        :aria-label="$LANG('0242', '下推')"
                        @click="openPushDialog(scope.row)">
                      </el-button>
                  </el-tooltip>
                  <el-tooltip :content="$LANG('0137', '弃审')" placement="top" effect="light">
                      <el-button
                        class="incoming-stkin-dialog__action-button"
                        type="text"
                        size="mini"
                        icon="iconfont icon-fanshenhe"
                        :disabled="cfmBool"
                        :aria-label="$LANG('0137', '弃审')"
                        @click="setStatus(scope.row, 'N')">
                      </el-button>
                  </el-tooltip>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      class="process-mind-map-dialog incoming-stkin-detail-dialog"
      v-dialogDrag
      :visible.sync="detailVisible"
      :width="dialogWidth"
      append-to-body
      top="4vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="resetDetailData">
      <div slot="title" class="incoming-stkin-dialog__title">
        <span>{{ detailMode === 'edit' ? $LANG('0921', '编辑记录') : $LANG('0971', '资料明细') }}</span>
      </div>
      <div class="incoming-stkin-detail-dialog__body" v-loading="detailLoading">
        <div v-for="(gpitem, gpind) in formGroups" :key="gpind">
          <div class="process-dialog-section incoming-stkin-detail-dialog__section">
            <span>{{ gpitem.gpnm }}</span>
          </div>
          <Form class="incoming-stkin-detail-dialog__form" :model="mainRow" :label-width="120" label-position="right" inline>
            <div
              v-for="(item, index) in gpitem.gplist"
              :key="index"
              :class="item.edcss === 'textarea' ? 'incoming-stkin-detail-dialog__form-cell incoming-stkin-detail-dialog__form-cell--wide' : 'incoming-stkin-detail-dialog__form-cell'">
              <FormItem
                v-if="item.fhide === 'N'"
                :class="item.edcss === 'textarea' ? 'incoming-stkin-detail-dialog__form-item incoming-stkin-detail-dialog__form-item--wide incoming-stkin-detail-dialog__form-item--textarea' : 'incoming-stkin-detail-dialog__form-item'"
                :prop="item.fldno">
                <template slot="label">{{ item.title }}</template>
                <el-date-picker
                  size="medium"
                  :disabled="isMainFieldDisabled(item)"
                  type="date"
                  v-if="item.edcss === 'date'"
                  v-model="mainRow[item.fldno]"
                  clearable
                  value-format="yyyy-MM-dd"
                  style="width:100%">
                </el-date-picker>
                <el-input-number
                  size="medium"
                  :precision="item.dotnum"
                  :disabled="isMainFieldDisabled(item)"
                  v-else-if="item.edcss === 'number'"
                  v-model="mainRow[item.fldno]"
                  style="width:100%">
                </el-input-number>
                <el-checkbox
                  size="medium"
                  border
                  disabled
                  v-else-if="item.edcss === 'checkbox'"
                  true-label="Y"
                  false-label="N"
                  v-model="mainRow[item.fldno]"
                  style="width:100%">
                </el-checkbox>
                <el-select
                  size="medium"
                  :disabled="isMainFieldDisabled(item)"
                  filterable
                  v-else-if="item.edcss === 'select'"
                  v-model="mainRow[item.fldno]"
                  style="width:100%">
                  <el-option
                    v-for="(option, optIndex) in comboArr[item.fldno] || []"
                    :key="optIndex"
                    :label="option.CNAME"
                    :value="option.CODE">
                  </el-option>
                </el-select>
                <el-input
                  size="medium"
                  :disabled="isMainFieldDisabled(item)"
                  v-else-if="item.edcss === 'textarea'"
                  resize="none"
                  type="textarea"
                  :rows="4"
                  v-model="mainRow[item.fldno]">
                </el-input>
                <el-tooltip
                  v-else-if="isMaterialCodeField(item)"
                  :content="displayText(mainRow[item.fldno])"
                  :disabled="!mainRow[item.fldno]"
                  placement="top-start"
                  effect="light">
                  <span class="incoming-stkin-detail-dialog__tooltip-input">
                    <el-input
                      size="medium"
                      :disabled="isMainFieldDisabled(item)"
                      v-model="mainRow[item.fldno]">
                    </el-input>
                  </span>
                </el-tooltip>
                <el-input
                  size="medium"
                  :disabled="isMainFieldDisabled(item)"
                  v-else
                  v-model="mainRow[item.fldno]">
                </el-input>
              </FormItem>
            </div>
          </Form>
        </div>
        <div class="process-dialog-section incoming-stkin-detail-dialog__section incoming-stkin-detail-dialog__section--detail">
          <span>{{ $LANG('0966', '入库明细') }}</span>
        </div>
        <el-table
          :data="detailData"
          border
          size="small"
          ref="detailTable"
          class="custom-table-border incoming-stkin-detail-dialog__table"
          show-summary
          :summary-method="getSummary"
          :cell-style="{ padding: '2px', 'font-size': '12px' }"
          cell-class-name="clearPadding2"
          height="34vh"
          highlight-current-row>
          <el-table-column :label="$LANG('0310', '序号')" type="index" width="60" fixed></el-table-column>
          <el-table-column
            v-for="item in visibleDetailColumns"
            :key="item.key"
            :prop="item.key"
            :label="item.title"
            show-overflow-tooltip
            :align="item.align"
            :sortable="item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'"
            :min-width="item.width">
            <template slot="header">{{ item.title }}<span v-if="item.notnull === 'Y'" class="incoming-stkin-detail-dialog__required">*</span></template>
            <template slot-scope="scope">
              <el-checkbox
                v-if="item.edcss === 'checkbox'"
                :disabled="isDetailFieldDisabled(item)"
                true-label="Y"
                false-label="N"
                v-model="scope.row[item.key]">
              </el-checkbox>
              <el-input
                v-else-if="item.edcss === 'number' && !isDetailFieldDisabled(item)"
                type="number"
                size="mini"
                v-model="scope.row[item.key]"
                @input="handleDetailNumberInput(scope.row)">
              </el-input>
              <el-date-picker
                v-else-if="item.edcss === 'date' && !isDetailFieldDisabled(item)"
                type="date"
                size="mini"
                v-model="scope.row[item.key]"
                :clearable="false"
                value-format="yyyy-MM-dd"
                style="width:100%">
              </el-date-picker>
              <el-input
                v-else-if="!isDetailFieldDisabled(item)"
                size="mini"
                v-model="scope.row[item.key]">
              </el-input>
              <span v-else v-text="displayText(scope.row[item.key])"></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="incoming-stkin-dialog__footer">
        <span class="incoming-stkin-dialog__hint">{{ $LANG('1497', '提示：订单审核后不能再编辑 , 如需编辑请弃审') }}</span>
        <el-button type="info" size="small" @click="detailVisible = false" icon="iconfont icon-shanchu">{{ $LANG('0132', '取消') }}</el-button>
        <el-button v-if="detailMode === 'edit'" :disabled="saveFlag || editBool" :loading="saving" size="small" type="primary" icon="iconfont icon-baocun" @click="saveDetail">{{ $LANG('0130', '保存') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="process-mind-map-dialog incoming-stkin-push-dialog"
      v-dialogDrag
      :visible.sync="pushVisible"
      :width="dialogWidth"
      append-to-body
      top="4vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="resetPushData">
      <div slot="title" class="incoming-stkin-dialog__title">
        <span>{{ $LANG('1164', '下推应付明细') }}</span>
      </div>
      <div class="incoming-stkin-push-dialog__body" v-loading="pushLoading">
        <div class="incoming-stkin-push-dialog__toolbar">
          <el-checkbox @change="selectAllPushRows" true-label="Y" false-label="N" v-model="pushSelectAll">
            <span>{{ $LANG('0263', '全选') }}</span>
          </el-checkbox>
          <el-button type="primary" size="mini" icon="iconfont icon-shipeiqi" @click="moveSelectedPushRows">{{ $LANG('1168', '下推选择记录') }}</el-button>
        </div>
        <el-table
          :data="availablePushRows"
          border
          size="small"
          class="custom-table-border incoming-stkin-push-dialog__table"
          :row-key="getPayRowKey"
          :cell-style="{ padding: '2px' }"
          height="360"
          highlight-current-row>
          <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"></el-table-column>
          <el-table-column
            v-for="item in pushVisibleColumns"
            :key="item.key"
            :prop="item.key"
            :label="item.title"
            show-overflow-tooltip
            :align="item.align"
            :sortable="item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'"
            :min-width="item.width">
            <template slot-scope="scope">
              <el-checkbox v-if="item.edcss === 'checkbox'" true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
              <el-input v-else-if="item.edcss === 'number'" type="number" size="mini" v-model="scope.row[item.key]" @input="handlePayAmountInput(scope.row)"></el-input>
              <el-input v-else-if="item.key === 'RMK'" size="mini" clearable v-model="scope.row[item.key]"></el-input>
              <span v-else v-text="displayText(scope.row[item.key])"></span>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :data="nextData"
          border
          size="small"
          class="custom-table-border incoming-stkin-push-dialog__table incoming-stkin-push-dialog__table--selected"
          :row-key="getDetailRowKey"
          :cell-style="{ padding: '2px' }"
          height="220"
          highlight-current-row>
          <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"></el-table-column>
          <el-table-column
            v-for="item in pushSelectedColumns"
            :key="item.key"
            :prop="item.key"
            :label="item.title"
            show-overflow-tooltip
            :align="item.align"
            :sortable="item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'"
            :min-width="item.width">
            <template slot="header"><span v-if="item.notnull === 'Y'" class="incoming-stkin-detail-dialog__required">{{ item.title }}</span><span v-else>{{ item.title }}</span></template>
            <template slot-scope="scope">
              <el-checkbox v-if="item.edcss === 'checkbox'" true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
              <span v-else v-text="displayText(scope.row[item.key])"></span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" :label="$LANG('0330', '操作')" align="center" width="80">
            <template slot-scope="scope">
              <el-button size="mini" type="text" icon="el-icon-close" @click="removePushRow(scope.row, scope.$index)">{{ $LANG('0131', '删除') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="incoming-stkin-dialog__footer">
        <el-button type="info" size="small" @click="pushVisible = false" icon="iconfont icon-shanchu">{{ $LANG('0132', '取消') }}</el-button>
        <el-button type="primary" size="small" :loading="pushing" icon="iconfont icon-shengcheng" @click="generatePay">{{ $LANG('1116', '生成应付单') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="process-mind-map-dialog incoming-stkin-confirm-dialog"
      :visible.sync="confirmVisible"
      width="400px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div slot="title" class="incoming-stkin-dialog__title">
        <span>{{ $LANG('1442', '提示') }}</span>
      </div>
      <div class="incoming-stkin-confirm-dialog__body">
        <el-checkbox :label="$LANG('2021', '采购完成')" true-label="Y" false-label="N" v-model="finishFlag"></el-checkbox>
        <el-checkbox :label="$LANG('2019', '请购完成')" true-label="Y" false-label="N" v-model="requestFinishFlag"></el-checkbox>
      </div>
      <div slot="footer" class="incoming-stkin-dialog__footer">
        <el-button type="info" size="small" @click="confirmVisible = false">{{ $LANG('0132', '取消') }}</el-button>
        <el-button type="primary" size="small" :loading="statusSaving" @click="confirmAudit">{{ $LANG('1638', '确定') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTabColOrData } from '../../api/user'
import { getDate } from '../../api/Select'

var HIDDEN_LIST_COLUMN_KEYS = ['SEL', 'FINVNO', 'DTLAMT', 'AMT', 'CHKAMT', 'OKAMT', 'ADDDTTM', 'UPDUSER', 'UPDDTTM']

export default {
  name: 'IncomingStkInDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    node: {
      type: Object,
      default: function () { return null }
    }
  },
  data: function () {
    return {
      loading: false,
      detailLoading: false,
      saving: false,
      statusSaving: false,
      pushing: false,
      pushLoading: false,
      columns: [],
      tableData: [],
      filters: {
        materialCode: '',
        supplierName: ''
      },
      detailVisible: false,
      detailMode: 'view',
      saveFlag: true,
      formGroups: [],
      detailColumns: [],
      pushColumns: [],
      comboArr: {},
      mainRow: {},
      detailData: [],
      requiredFields: [],
      delDtlArr: [],
      editBool: false,
      delBool: false,
      cfmBool: false,
      cancelBool: false,
      pushVisible: false,
      pushRow: null,
      pushRows: [],
      nextData: [],
      pushSelectAll: 'N',
      confirmVisible: false,
      confirmRow: null,
      finishFlag: 'Y',
      requestFinishFlag: 'N'
    }
  },
  computed: {
    innerVisible: {
      get: function () { return this.visible },
      set: function (value) { this.$emit('update:visible', value) }
    },
    visibleColumns: function () {
      return this.columns.filter(function (item) {
        return item.thide === 'N' && HIDDEN_LIST_COLUMN_KEYS.indexOf(String(item.key || '').toUpperCase()) === -1
      })
    },
    filteredTableData: function () {
      var materialCode = String(this.filters.materialCode || '').trim().toLowerCase()
      var supplierName = String(this.filters.supplierName || '').trim().toLowerCase()
      return this.tableData.filter(function (row) {
        var rowMaterialCode = String(row.OUTMATNO || row.MATNO || '').toLowerCase()
        var rowSupplierName = String(row.SUPNM || '').toLowerCase()
        return (!materialCode || rowMaterialCode.indexOf(materialCode) !== -1) &&
          (!supplierName || rowSupplierName.indexOf(supplierName) !== -1)
      })
    },
    visibleDetailColumns: function () {
      return this.detailColumns.filter(function (item) { return item.thide === 'N' })
    },
    pushVisibleColumns: function () {
      return this.pushColumns.filter(function (item) { return item.thide === 'N' && item.key !== 'RN' })
    },
    pushSelectedColumns: function () {
      return this.pushColumns.filter(function (item) { return item.thide === 'N' && item.key !== 'RN' && item.key !== 'SEL' })
    },
    availablePushRows: function () {
      return this.pushRows.filter(function (item) { return item.ISNEXT === 'N' })
    },
    dialogWidth: function () {
      return (window.innerWidth - 140) + 'px'
    },
    vUsername: function () {
      return this.$cookies.get('v_telno')
    },

    vCorpid: function () {
      return this.$cookies.get('v_corpid')
    },
    vUsernm: function () {
      return this.$cookies.get('v_usernm')
    },
    vAdmin: function () {
      return this.$cookies.get('v_admin')
    },
    tableUrl: function () {
      return  'xuper_auth/getTableRecMany'
    },
    formGroupUrl: function () {
      return  'xuper_auth/getFormGroup'
    },
    noauthUrl: function () {
      return  'xuper_auth/getBaseData'
    }
  },
  methods: {
    resetData: function () {
      this.loading = false
      this.columns = []
      this.tableData = []
      this.detailVisible = false
      this.pushVisible = false
      this.confirmVisible = false
      this.resetFilters()
      this.resetDetailData()
      this.resetPushData()
    },
    resetFilters: function () {
      this.filters.materialCode = ''
      this.filters.supplierName = ''
    },
    resetDetailData: function () {
      this.detailLoading = false
      this.saving = false
      this.detailMode = 'view'
      this.saveFlag = true
      this.formGroups = []
      this.detailColumns = []
      this.pushColumns = []
      this.comboArr = {}
      this.mainRow = {}
      this.detailData = []
      this.delDtlArr = []
    },
    resetPushData: function () {
      this.pushLoading = false
      this.pushing = false
      this.pushRow = null
      this.pushRows = []
      this.nextData = []
      this.pushSelectAll = 'N'
    },
    loadData: function () {
      this.loading = true
      Promise.all([this.loadListColumns(), this.loadRows(), this.loadPermission(), this.loadRequiredFields()]).then(function (result) {
        this.columns = result[0] || []
        this.tableData = result[1] || []
        this.requiredFields = result[3] || []
        this.$nextTick(function () {
          if (this.$refs.listTable && this.$refs.listTable.doLayout) this.$refs.listTable.doLayout()
        })
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.loading = false
      }.bind(this))
    },
    reloadAfterChange: function () {
      return this.loadRows().then(function (rows) {
        this.tableData = rows || []
        this.$emit('changed')
        this.$nextTick(function () {
          if (this.$refs.listTable && this.$refs.listTable.doLayout) this.$refs.listTable.doLayout()
        })
      }.bind(this))
    },
    loadPermission: function () {
      this.editBool = false
      this.delBool = false
      this.cfmBool = false
      this.cancelBool = false
      return getTabColOrData(this.tableUrl, 'v_sys_user_priv', 'userno', this.vUsername, 'frmidseq', '112', '', '', '').then(function (res) {
        if (this.vAdmin !== 'N') return
        var rows = (res && res.result) || []
        var row = rows[0] || {}
        this.editBool = row.ISUPD === 'N'
        this.delBool = row.ISDEL === 'N'
        this.cfmBool = row.ISCFM === 'N'
        this.cancelBool = row.ISCANCEL === 'N'
      }.bind(this))
    },
    loadRequiredFields: function () {
      return getTabColOrData(this.tableUrl,   'v_sys_form_fld', 'idseq', '112', 'LSTSEQ', '1', 'NOTNULL', 'Y', '').then(function (res) {
        return ((res && res.result) || []).map(function (item) {
          return this.normalizeColumn(item)
        }.bind(this))
      }.bind(this))
    },
    loadListColumns: function () {
      return this.loadColumns('1')
    },
    loadDetailColumns: function () {
      return this.loadColumns('2')
    },
    loadPushColumns: function () {
      return this.loadColumns('3', ' order by sortby,itmseq')
    },
    loadColumns: function (lstseq, orderBy) {
      return getTabColOrData(this.tableUrl, 'v_sys_form_fld', 'idseq', '112', 'lstseq', lstseq, '', '', orderBy || ' order by sortby,lstseq').then(function (res) {
        var list = (res && res.result) || []
        return list.map(function (item) {
          return this.normalizeColumn(item)
        }.bind(this))
      }.bind(this))
    },
    normalizeColumn: function (item) {
      return {
        title: this.$translate.getColTitle(item, this.$store.state.lang),
        key: item.key || item.FLDNO,
        fldno: item.FLDNO || item.key,
        align: item.align,
        width: item.width,
        thide: item.THIDE,
        fhide: item.FHIDE,
        edcss: item.EDCSS,
        disabled: item.DISABLED,
        dotnum: item.DOTNUM,
        sortable: item.SORTABLE,
        notnull: item.NOTNULL,
        combo: item.COMBO
      }
    },
    loadRows: function () {
      var payload
      try {
        payload = this.getDynamicPayload()
      } catch (error) {
        return Promise.resolve([])
      }
      return getTabColOrData(
        this.tableUrl,

        payload.p_table,
        payload.p_key,
        payload.p_value,
        payload.p_key2,
        payload.p_value2,
        payload.p_key3,
        payload.p_value3,
        payload.p_cond
      ).then(function (res) {
        return (res && res.result) || []
      })
    },
    getNodeData: function () {
      return (this.node && this.node.nodeData) || {}
    },
    getRequiredSourceParams: function () {
      var row = this.getNodeData()
      var params = {
        ORDNO: row.ORDNO || row.IDNO || row.REFIDNO,
        CORPID: row.CORPID
      }
      var missing = []
      Object.keys(params).forEach(function (key) {
        if (params[key] === undefined || params[key] === null || params[key] === '') missing.push(key)
      })
      if (missing.length) throw new Error('MISSING_SOURCE_PARAMS')
      return params
    },
    escapeQueryValue: function (value) {
      return String(value === undefined || value === null ? '' : value).trim().replace(/'/g, "''")
    },
    getDynamicPayload: function () {
      var params = this.getRequiredSourceParams()
      return {
        p_key: 'IDTY',
        p_value: 'POIN',
        p_key2: 'CORPID',
        p_value2: params.CORPID,
        p_key3: '',
        p_value3: '',
        p_table: 'V_IC_STK_POIN',
        p_cond: " and IDNO like '%%' and ORDNO like '%" + this.escapeQueryValue(params.ORDNO) + "%' ORDER BY IDNO DESC"
      }
    },
    openDetail: function (row, mode) {
      if (!row) return
      this.detailVisible = true
      this.detailLoading = true
      this.detailMode = mode === 'edit' ? 'edit' : 'view'
      this.saveFlag = this.detailMode !== 'edit' || row.STFG === 'Y'
      this.mainRow = JSON.parse(JSON.stringify(Object.assign({}, row, { IDSEQ: row.IDSEQ })))
      Promise.all([
        this.loadFormGroups(),
        this.loadDetailColumns(),
        this.loadFormCombos(),
        this.loadDetailRows(row.IDSEQ)
      ]).then(function (result) {
        this.formGroups = result[0] || []
        this.detailColumns = result[1] || []
        this.comboArr = result[2] || {}
        this.detailData = result[3] || []
        this.$nextTick(function () {
          if (this.$refs.listTable && this.$refs.listTable.doLayout) this.$refs.listTable.doLayout()
          if (this.$refs.detailTable && this.$refs.detailTable.doLayout) this.$refs.detailTable.doLayout()
        })
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.detailLoading = false
      }.bind(this))
    },
    loadFormGroups: function () {
      return getTabColOrData(this.formGroupUrl,  'v_sys_form_fld', 'idseq', '112', 'gpnm,gpsort', '', 'lstseq', '1', ' order by gpsort').then(function (res) {
        var groups = (res && res.result) || []
        return groups.map(function (group) {
          var nextGroup = Object.assign({}, group)
          nextGroup.gplist = (group.gplist || []).map(function (item) {
            return this.normalizeColumn(item)
          }.bind(this)).filter(function (item) {
            return item && item.fhide === 'N'
          })
          return nextGroup
        }.bind(this)).filter(function (group) {
          return group.gplist && group.gplist.length
        })
      }.bind(this))
    },
    loadFormCombos: function () {
      return getTabColOrData(this.tableUrl,   'v_sys_form_fld', 'idseq', '112', 'edcss', 'select', '', '', ' and lstseq in (1,2)').then(function (res) {
        var fields = (res && res.result) || []
        return Promise.all(fields.map(function (field) {
          return this.loadComboOptions(field)
        }.bind(this))).then(function (results) {
          var comboMap = {}
          results.forEach(function (item) {
            if (item.fldno) comboMap[item.fldno] = item.options
            if (item.key) comboMap[item.key] = item.options
          })
          return comboMap
        })
      }.bind(this))
    },
    loadComboOptions: function (field) {
      if (!field || !field.COMBO) return Promise.resolve({ fldno: field && field.FLDNO, key: field && field.key, options: [] })
      return getTabColOrData(this.noauthUrl,  'v_sys_base', 'parentno', field.COMBO, '', '', '', '', '').then(function (res) {
        return {
          fldno: field.FLDNO,
          key: field.key,
          options: (res && res.result) || []
        }
      })
    },
    loadDetailRows: function (idseq) {
      if (!idseq) return Promise.resolve([])
      return getTabColOrData(this.tableUrl,  'v_IC_STKdtl', 'idseq', idseq, '', '', '', '', ' ORDER BY LSTSEQ').then(function (res) {
        return (res && res.result) || []
      })
    },
    isMainFieldDisabled: function (item) {
      return this.saveFlag || (item && item.disabled === 'Y')
    },
    isDetailFieldDisabled: function (item) {
      return this.saveFlag || !item || item.disabled !== 'N'
    },
    handleDetailNumberInput: function (row) {
      if (!row) return
      row.AMT = (Number(row.ACTQTY || 0) * Number(row.TAXPRC || 0)).toFixed(2)
    },
    validateDetail: function () {
      var missingTitle = ''
      this.requiredFields.some(function (item) {
        if (!this.mainRow[item.fldno]) {
          missingTitle = item.title
          return true
        }
        return false
      }.bind(this))
      if (missingTitle) {
        this.$emit('error', missingTitle + this.$LANG('2051', '不能为空'))
        return false
      }
      this.detailData.some(function (row) {
        return this.detailColumns.filter(function (item) { return item.notnull === 'Y' }).some(function (item) {
          if (!row[item.key]) {
            missingTitle = item.title
            return true
          }
          return false
        })
      }.bind(this))
      if (missingTitle) {
        this.$emit('error', missingTitle + this.$LANG('2051', '不能为空'))
        return false
      }
      return true
    },
    saveDetail: function () {
      if (this.saveFlag || this.editBool || this.saving) return
      if (!this.validateDetail()) return
      this.saving = true
      this.$axios({
        method: 'post',
        url:  'xuper_auth/formOneSave',
        data: { p_json: JSON.stringify(Object.assign({}, this.mainRow, { CORPID: this.vCorpid })), p_table: 'IC_STK', frmid: '112' }
      }).then(function (res) {
        if (res && res.result === 'OK') {
          var idseq = res.idseq
          return this.$axios({
            method: 'post',
            url:  'xuper_auth/batDtlSave2',
            data: { p_json: JSON.stringify(this.detailData), p_table: 'IC_STKDTL', p_idseq: idseq, p_action: 'S' }
          }).then(function () {
            var deletePromise = Promise.resolve()
            if (this.delDtlArr.length) {
              deletePromise = this.$axios({
                method: 'post',
                url:  'xuper_auth/batDtlSave2',
                data: { p_json: JSON.stringify(this.delDtlArr), p_table: 'IC_STKdtl', p_idseq: idseq, p_action: 'D' }
              })
            }
            return deletePromise.then(function () {
              this.detailVisible = false
              return this.reloadAfterChange()
            }.bind(this))
          }.bind(this))
        }
        this.$emit('error', (res && res.result) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.saving = false
      }.bind(this))
    },
    setStatus: function (row, value) {
      if (!row) return
      if (value === 'Y' && this.delBool) return
      if (value === 'N' && this.cfmBool) return
      if (value === 'Y') {
        this.confirmRow = row
        this.finishFlag = 'Y'
        this.requestFinishFlag = 'N'
        this.confirmVisible = true
        return
      }
      var statusText = value === 'N' ? this.$LANG('0137', '弃审') : this.$LANG('0257', '作废')
      this.$confirm(this.$LANG('1564', '你确定要') + statusText + this.$LANG('1565', '此单据吗?'), this.$LANG('1442', '提示'), {
        confirmButtonText: this.$LANG('1638', '确定'),
        cancelButtonText: this.$LANG('0132', '取消'),
        customClass: 'process-mind-map-message-box',
        showClose: false,
        type: 'info'
      }).then(function () {
        var cond = " set stfg='" + value + "' ,chkuser=null,chkdttm=null,ISPO_OK='N',upduser='" + this.escapeQueryValue(this.vUsernm) + "',upddttm='" + getDate('full') + "'"
        return this.updateStatus(row, cond)
      }.bind(this)).catch(function () {})
    },
    confirmAudit: function () {
      if (!this.confirmRow || this.statusSaving) return
      this.statusSaving = true
      var chkuser = this.escapeQueryValue(this.vUsernm)
      var chkdttm = getDate('full')
      var cond = " set stfg='Y' ,chkuser='" + chkuser + "',chkdttm='" + chkdttm + "',ISPO_OK='" + this.finishFlag + "',ISREQ='" + this.requestFinishFlag + "'"
      this.updateStatus(this.confirmRow, cond).then(function () {
        this.confirmVisible = false
        this.confirmRow = null
      }.bind(this)).finally(function () {
        this.statusSaving = false
      }.bind(this))
    },
    updateStatus: function (row, cond) {
      return this.$axios({
        method: 'post',
        url:  'xuper_auth/updateRec',
        data: { p_key: 'idseq', p_value: row.IDSEQ, p_table: 'IC_STK', p_cond: cond }
      }).then(function (res) {
        if (res && res.code === '200') return this.reloadAfterChange()
        var message = (res && res.result) || this.$LANG('1442', '提示')
        if (message.indexOf && message.indexOf('ORA-04088') > -1) message = this.$LANG('1559', '库存数量不足，请核查')
        this.$emit('error', message)
      }.bind(this))
    },
    openPushDialog: function (row) {
      if (!row || this.editBool) return
      this.pushVisible = true
      this.pushLoading = true
      this.pushRow = row
      this.pushSelectAll = 'N'
      this.nextData = []
      Promise.all([this.loadPushColumns(), this.loadPayRows(row.IDSEQ)]).then(function (result) {
        this.pushColumns = result[0] || []
        this.pushRows = (result[1] || []).map(function (item, index) {
          return Object.assign({}, item, { ISNEXT: 'N', SEL: 'N', index: index })
        })
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.pushLoading = false
      }.bind(this))
    },
    loadPayRows: function (idseq) {
      if (!idseq) return Promise.resolve([])
      return getTabColOrData(this.tableUrl,  'V_IC_STKDTL', '', '', '', '', '', '', " and idseq in ('" + this.escapeQueryValue(idseq) + "')").then(function (res) {
        return (res && res.result) || []
      })
    },
    selectAllPushRows: function () {
      this.pushRows.forEach(function (item) {
        item.SEL = this.pushSelectAll
      }.bind(this))
    },
    handlePayAmountInput: function (row) {
      if (!row) return
      if (row.CHKAMT) row.PAYAMT = (Number(row.ACTQTY || 0) * Number(row.PRC || 0) - Number(row.CHKAMT || 0)).toFixed(2)
      else row.PAYAMT = (Number(row.ACTQTY || 0) * Number(row.PRC || 0)).toFixed(2)
    },
    moveSelectedPushRows: function () {
      var selected = this.pushRows.filter(function (item) { return item.SEL === 'Y' && item.ISNEXT === 'N' })
      if (!selected.length) {
        this.$emit('error', this.$LANG('1684', '请选择记录'))
        return
      }
      selected.forEach(function (item) {
        item.ISNEXT = 'Y'
        item.SEL = 'N'
        this.nextData.push(Object.assign({}, item))
      }.bind(this))
    },
    removePushRow: function (row, index) {
      this.pushRows.push(Object.assign({}, row, { ISNEXT: 'N', SEL: 'N' }))
      this.nextData.splice(index, 1)
    },
    generatePay: function () {
      if (!this.nextData.length) {
        this.$emit('error', this.$LANG('1641', '下推记录为空'))
        return
      }
      var hasEmptyAmt = this.nextData.some(function (item) {
        return !item.PAYAMT || Number(item.PAYAMT) === 0
      })
      if (hasEmptyAmt) {
        this.$emit('error', this.$LANG('0801', '请检查下推记录：金额') + '>0')
        return
      }
      this.$confirm(this.$LANG('1603', '你确定要下推生成应付单吗'), this.$LANG('1442', '提示'), {
        confirmButtonText: this.$LANG('1638', '确定'),
        cancelButtonText: this.$LANG('0132', '取消'),
        customClass: 'process-mind-map-message-box',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'info'
      }).then(function () {
        this.pushing = true
        return this.$axios({
          method: 'post',
          url:  'xuper_auth/next_genpay',
          data: { corpid: this.vCorpid, p_json: JSON.stringify(this.nextData), p_user: this.vUsername, p_action: 'STK' + this.vUsername + getDate('full') + this.vUsername }
        }).then(function (res) {
          if (res && res.code === '200') {
            this.$notify({ title: this.$LANG('1441', '成功'), message: this.$LANG('1484', '已成功下推应付单，请到费用报销单界面中查看'), type: 'success' })
            this.pushVisible = false
            return this.reloadAfterChange()
          }
          this.$emit('error', this.$LANG('1446', '下推失败！') + ((res && res.result) || ''))
        }.bind(this)).finally(function () {
          this.pushing = false
        }.bind(this))
      }.bind(this)).catch(function () {})
    },
    getDetailRowKey: function (row) {
      return String((row && row.IDSEQ) || '') + '-' + String((row && row.LSTSEQ) || '')
    },
    getPayRowKey: function (row) {
      return String((row && row.index) || '')
    },
    isYesNoField: function (item) {
      return item && (item.edcss === 'checkbox' || item.key === 'STFG' || item.key === 'ISSTK')
    },
    isMaterialCodeField: function (item) {
      if (!item) return false
      var fieldNo = String(item.fldno || item.key || '').toUpperCase()
      return fieldNo === 'MATNO' || item.title === '物料编码'
    },
    displayText: function (value) {
      return value === undefined || value === null || value === '' ? '-' : value
    },
    headStyle: function (params) {
      var column = params.column || {}
      if (this.getSummaryFields().indexOf(column.property) > -1) return 'color:red'
    },
    getSummaryFields: function () {
      return ['QTY', 'POQTY', 'SENDQTY', 'BADQTY', 'OKQTY', 'STKQTY', 'INQTY', 'RTNQTY', 'QCQTY', 'ACTQTY', 'CHKQTY', 'QUALQTY', 'NOQTY', 'AMT']
    },
    getSummary: function (param) {
      var sums = []
      var sumFields = this.getSummaryFields()
      param.columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = this.$LANG('0280', '合计')
          return
        }
        if (sumFields.indexOf(column.property) === -1) return
        var values = param.data.map(function (item) { return Number(item[column.property]) })
        var sumValue = values.reduce(function (prev, curr) {
          if (!isNaN(curr)) return Number(prev) + Number(curr)
          return prev
        }, 0)
        sums[index] = sumValue ? sumValue.toFixed(2) : ''
      }.bind(this))
      return sums
    }
  }
}
</script>

<style scoped lang="less">
.incoming-stkin-dialog__title {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 56px 0 20px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
  color: #1f2f3d;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}
.incoming-stkin-dialog__body,
.incoming-stkin-push-dialog__body {
  min-height: 70vh;
}
.incoming-stkin-dialog__filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}
.incoming-stkin-dialog__filters .el-input {
  width: 150px;
}
.incoming-stkin-dialog__table,
.incoming-stkin-detail-dialog__table,
.incoming-stkin-push-dialog__table {
  width: 100%;
}
.incoming-stkin-dialog__idno {
  color: #606266;
  font-size: 13px;
  font-weight: 700;
  border-bottom: 1px solid red;
}
.incoming-stkin-dialog__action-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.incoming-stkin-dialog__action-button {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 32px !important;
  min-width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 50% !important;
  color: #409eff;
  line-height: 32px !important;
}
.incoming-stkin-dialog__action-button i {
  display: inline-block;
  width: 16px !important;
  height: 16px !important;
  margin: 0 !important;
  font-size: 16px !important;
  line-height: 16px !important;
  vertical-align: middle;
}
.incoming-stkin-dialog__action-button ::v-deep i,
.incoming-stkin-dialog__action-button ::v-deep [class^="iconfont"],
.incoming-stkin-dialog__action-button ::v-deep [class*=" iconfont"] {
  display: inline-block;
  width: 16px !important;
  height: 16px !important;
  margin: 0 !important;
  font-size: 16px !important;
  line-height: 16px !important;
}
.incoming-stkin-dialog__action-button:hover,
.incoming-stkin-dialog__action-button:focus {
  background: rgba(64, 158, 255, .1);
  color: #1f78ff;
}
.incoming-stkin-dialog__action-button.is-disabled,
.incoming-stkin-dialog__action-button.is-disabled:hover,
.incoming-stkin-dialog__action-button.is-disabled:focus {
  background: transparent;
  color: #c0c4cc;
}
.incoming-stkin-detail-dialog__body {
  height: 82vh;
  padding: 2px 0 0;
  overflow-y: auto;
  background: #fff;
}
.incoming-stkin-detail-dialog__section {
  margin: 10px 0 12px;
}
.incoming-stkin-detail-dialog__section--detail {
  margin-top: 20px;
}
.incoming-stkin-detail-dialog__form {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 48px;
  row-gap: 16px;
  padding: 0 22px 18px 8px;
  box-sizing: border-box;
}
.incoming-stkin-detail-dialog__form-item {
  width: 100%;
  min-width: 0;
  margin: 0;
}
.incoming-stkin-detail-dialog__form-cell {
  min-width: 0;
}
.incoming-stkin-detail-dialog__form-cell--wide {
  grid-column: 1 / -1;
}
.incoming-stkin-detail-dialog__form-item--wide {
  width: 100%;
}
.incoming-stkin-detail-dialog__tooltip-input {
  display: block;
  width: 100%;
}
.incoming-stkin-detail-dialog__table {
  margin-top: 0;
}
.incoming-stkin-detail-dialog__required {
  color: red;
}
.incoming-stkin-dialog__footer {
  text-align: right;
}
.incoming-stkin-dialog__footer .el-button + .el-button {
  margin-left: 30px;
}
.incoming-stkin-dialog__hint {
  margin-right: 20px;
  color: #ed4014;
  font-size: 14px;
  font-weight: 600;
}
.incoming-stkin-push-dialog__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 36px;
  padding: 0 8px;
  background: #1f6f8b;
  color: #fff;
}
.incoming-stkin-push-dialog__table--selected {
  margin-top: 12px;
}
.incoming-stkin-confirm-dialog__body {
  display: flex;
  align-items: center;
  gap: 18px;
  min-height: 64px;
  padding: 0 8px;
}
@media (max-width: 1200px) {
  .incoming-stkin-detail-dialog__form {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 24px;
  }
}
</style>

<style lang="less">
.process-mind-map-dialog.incoming-stkin-list-dialog {
  .incoming-stkin-dialog__filters .el-input--mini .el-input__inner {
    height: 28px !important;
    min-height: 28px !important;
    line-height: 28px !important;
    font-size: 12px !important;
  }
  .incoming-stkin-dialog__filters .el-input--mini .el-input__icon {
    height: 28px;
    line-height: 28px;
  }
  .incoming-stkin-dialog__filters .el-input__suffix-inner {
    display: inline-flex;
    align-items: center;
    height: 100%;
    vertical-align: top;
  }
  .incoming-stkin-dialog__reset {
    height: 28px !important;
    min-height: 28px !important;
    padding: 0 12px !important;
    font-size: 12px !important;
    line-height: 28px !important;
  }
  .incoming-stkin-dialog__table .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #fff !important;
  }
}
</style>
